import { c as _c } from "react/compiler-runtime";
import { useCallback, useMemo } from 'react';
import { FilterPipelineFilter } from 'record-it-components/hooks/useFilterPipeline/useFilterPipeline';
import { EntityName } from 'record-it-time-common/EntityName';
import { ArrayUtils } from 'record-it-utils/utils/ArrayUtils/ArrayUtils';
import { AppEntityManager } from '../../../classes/entities/AppEntityManager';
import { User } from '../../../classes/entities/User/userTypes';
import { WorkTimeEntry } from '../../../classes/entities/WorkTimeEntry/workTimeEntryTypes';
import { RoutePaths } from '../../../classes/RoutePaths/RoutePaths';
import { CurrentUserContextValue } from '../../../context/CurrentUserContext';
import { createUserGroupIdUrlFilter } from '../../../filters/userGroupIdUrlFilter/userGroupIdUrlFilter';
import { createUserIdUrlFilter } from '../../../filters/userIdUrlFilter/userIdUrlFilter';
import { Callback, useComputedEntityResult } from '../../../hooks/entity/useComputedEntityResult/useComputedEntityResult';
import { useEntityManager } from '../../../hooks/entity/useEntityManager';
export function useWorkTimeAdminPageFilters(t0) {
  const $ = _c(15);
  const {
    userGroupId,
    userId,
    getRequiredCurrentUserPermissions
  } = t0;
  const {
    entityManager
  } = useEntityManager();
  const users = useUsersOfUserGroup(userGroupId);
  let t1;
  if ($[0] !== entityManager || $[1] !== getRequiredCurrentUserPermissions || $[2] !== userGroupId) {
    const permissions = getRequiredCurrentUserPermissions();
    let t2;
    if ($[4] !== entityManager) {
      t2 = urlUserGroupId => RoutePaths.adminWorkTime(urlUserGroupId, getFirstUserIdOfUserGroup({
        userGroupId: urlUserGroupId,
        entityManager
      }));
      $[4] = entityManager;
      $[5] = t2;
    } else {
      t2 = $[5];
    }
    t1 = createUserGroupIdUrlFilter({
      userGroups: permissions.getEditableUserGroupsForTimeTrackingActivityCompilations(),
      currentUserGroupId: userGroupId,
      createUrl: t2
    });
    $[0] = entityManager;
    $[1] = getRequiredCurrentUserPermissions;
    $[2] = userGroupId;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[6] !== userGroupId) {
    t2 = urlUserId => RoutePaths.adminWorkTime(userGroupId, urlUserId);
    $[6] = userGroupId;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  let t3;
  if ($[8] !== t2 || $[9] !== userId || $[10] !== users) {
    t3 = createUserIdUrlFilter({
      users,
      currentUserId: userId,
      createUrl: t2
    });
    $[8] = t2;
    $[9] = userId;
    $[10] = users;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  let t4;
  if ($[12] !== t1 || $[13] !== t3) {
    t4 = [t1, t3];
    $[12] = t1;
    $[13] = t3;
    $[14] = t4;
  } else {
    t4 = $[14];
  }
  return t4;
}
function getFirstUserIdOfUserGroup({
  userGroupId,
  entityManager
}: {
  userGroupId: string;
  entityManager: AppEntityManager;
}): string {
  const relations = entityManager.entityRepositoryContainer.getByEntityName(EntityName.UserGroupToUser).getByUserGroupId(userGroupId);
  const firstRelation = relations[0];
  if (!firstRelation) {
    throw new Error(`no relations found for userGroup ${userGroupId}`);
  }
  return firstRelation.userId;
}
function useUsersOfUserGroup(userGroupId) {
  const $ = _c(5);
  let t0;
  if ($[0] !== userGroupId) {
    t0 = t1 => {
      const {
        userGroupToUserRepository,
        userRepository
      } = t1;
      return userGroupToUserRepository.getByUserGroupId(userGroupId).map(relation => userRepository.getById(relation.userId)).filter(_temp);
    };
    $[0] = userGroupId;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const callback = t0;
  let t1;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = [EntityName.User, EntityName.UserGroupToUser];
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== callback) {
    t2 = {
      entityNames: t1,
      callback,
      resultsAreEqual: _temp2
    };
    $[3] = callback;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return useComputedEntityResult(t2);
}
function _temp2(a, b) {
  return ArrayUtils.areShallowEqual(a, b);
}
function _temp(user) {
  return !!user;
}